import { useI18N } from "@sundae/react-hooks";
import { ADA_ASSET_DECIMAL } from "@sundaeswap/core";
import { useMemo } from "react";
import { ADA_METADATA } from "../../constants/cardano.constants";
import { useTasteTestContext } from "../../pages/TasteTestDetail/context";
import { getAssetName } from "../../utils/assets.utils";
import { numberI18n } from "../../utils/number-format";
import { useTasteTestWithdrawAmounts } from "./useTasteTestWithdrawAmounts";

export const useTasteTestOrderAmountsI18n = () => {
  const { currentLocale } = useI18N();
  const {
    derived: { depositAssetAmount },
    state: { actionType },
  } = useTasteTestContext();
  const { total: totalWithdrawalAmount } = useTasteTestWithdrawAmounts();

  const { amount, token } = useMemo(() => {
    const amount =
      actionType === "withdraw"
        ? totalWithdrawalAmount?.value?.toNumber() ?? 0
        : depositAssetAmount?.value.toNumber() ?? 0;
    return {
      amount: numberI18n(
        amount,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: ADA_ASSET_DECIMAL,
        },
        currentLocale
      ),
      token: getAssetName(ADA_METADATA),
    };
  }, [
    actionType,
    totalWithdrawalAmount?.value?.toNumber(),
    depositAssetAmount?.metadata,
    depositAssetAmount?.value?.toNumber(),
  ]);

  return {
    amount,
    token,
  };
};
